<template>
  <div style="min-height: 500px;">

    <alert-message v-if="!showSearchSpinner && showErrorMessage" class="large-panel"></alert-message>
    <div class="search-result-card large-panel " v-if="isSearchStringValid && filteredSearchResults && filteredSearchResults.length>0">
      <div v-for="(searchResult, key) in filteredSearchResults" :key="key" class="mb-3 mr-3">
        <div class="row search-results-panel m-0">
          <div class="col-md-12">
            <a :href="buildSearchResultUrl(searchResult)"
              class="search-result-title"
              @click="redirectToSolutionsModal(searchResult,$event)"
            >{{ searchResult.name |  truncateHTML(30)}}
              <font-awesome-icon
                  class="ml-1"
                  icon="external-link-alt"
                  v-if="searchResult.isExternalLink"
              />
            </a>
            <div class="search-result-desc">
              <div v-if="searchResult.description" >{{searchResult.description |  truncateHTML(40)}}</div>
              <div v-else>{{searchResult.name |  truncateHTML(20)}}</div>
            </div>
            <div class="row content-card" v-if="searchResult.type">
              <div class="col-12">
                <span class="span-tag">{{searchResult.type}}</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div v-else-if="isSearchStringValid && !this.showSearchSpinner && noResultsFound">
      <div class="no-match-card">
        <h4>Sorry, no records were found to match your keywords.</h4>
      </div>
    </div>
    <div v-if="!isSearchStringValid" class="no-match-card">
      <h4>Please type keywords to search.</h4>
    </div>

    <div class="pl-3" v-if="!this.showSearchSpinner"><support /></div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import api from "@/api"
import AlertMessage from "./AlertMessage";
import CONSTANTS from "@/store/constants";
import filters from "@/filters/filter";
import debounce from "lodash/debounce";
import Support from "@/components/Support";

export default {
  name: "SearchResults",
  components: {AlertMessage, Support},
  props: ["searchTerm"],
  data() {
    return {
      showErrorMessage:false,
      formattedESResults:[]
    };
  },
  filters,
  watch: {
    searchTerm(newVal){
      if(this.currentAppData.enableEnterpriseSearch && this.currentAppData.enterpriseSearchQuery && newVal.trim().length>=2) {
        this.setShowSearchSpinner(true);
        this.searchDebounce(this);
      }
    }
  },
  created() {
    if (this.currentAppData.enableEnterpriseSearch && this.currentAppData.enterpriseSearchQuery && this.isSearchStringValid) {
      this.setShowSearchSpinner(true);
      this.formattedESResults.length === 0 ? this.getEnterpriseSearchResults() : ''
    }
  },
  computed: {
    isSearchStringValid() {
      return this.searchTerm.length >= 2
    },
    noResultsFound(){
      if(this.currentAppData.enableEnterpriseSearch && this.currentAppData.enterpriseSearchQuery) {
        let noResults =  this.formattedESResults ==null || this.formattedESResults.length == 0;
        if(noResults){
          this.$hhMixpanel.trackEvent("Page Hit: Guides Enterprise Search - No Result Search", {
            subEvent: "query="+this.searchTerm
          });
        }
        return noResults;
      }else{
        return this.filteredSearchResults ==null || this.filteredSearchResults.length == 0;
      }

    },
    ...mapGetters(["allCategories", "currentAlias","currentAppData","showSearchSpinner"]),

    filteredSearchResults() {
      let searchResults = []
     if(this.currentAppData.enableEnterpriseSearch && this.currentAppData.enterpriseSearchQuery){

       return this.formattedESResults;

     }else{
       this.allCategories.forEach(category => {

         this.searchCategoryForSubstring(category, 'name') !== undefined ? searchResults.push(category) : ''
         this.searchCategoryForSubstring(category, 'description') !== undefined ? searchResults.push(category) : ''
         this.searchCategoryForSubStringInArray(category, 'searchTags') !== undefined ? searchResults.push(category) : ''

         if(category.childCategories && category.childCategories.length > 0) {
           category.childCategories.forEach(childCategory => {

             this.searchCategoryForSubstring(childCategory, 'name') !== undefined ? searchResults.push(childCategory) : ''
             this.searchCategoryForSubstring(childCategory, 'description') !== undefined ? searchResults.push(childCategory) : ''
             this.searchCategoryForSubStringInArray(childCategory, 'searchTags') !== undefined ? searchResults.push(childCategory) : ''

           })
         }
       })

       let uniqueSearchResults = this.getUniqueListBy(searchResults, 'id')

       this.trackEvent("Page Hit: Guides Search",this.searchTerm);

       return uniqueSearchResults


     }
    }
  },
  methods: {
    ...mapMutations(["setSearchResult","setBreadcrumbItems","setShowSearchSpinner","setErrorMessage"]),
    getEnterpriseSearchResults(){
      this.showErrorMessage = false;

      api.getSearchResults(this.searchTerm,this.currentAppData.enterpriseSearchQuery,this.currentAppData.enterpriseSearchResultsLength).then((response)=>{
        let esResults = [];
        let resultUrls = [];
        response.data.data.search.hits.forEach(esResult=>{
          esResult.name = esResult.title;
          esResult.description = esResult.content;
          esResult.linkName = esResult.title;
          esResult.linkValue  = esResult.url;
          esResult.isExternalLink = this.checkForExternalLink(esResult.linkValue)
          if(!resultUrls || !resultUrls.includes(esResult.linkValue)){
            esResults.push(esResult);
            resultUrls.push(esResult.linkValue);
          }
        });
        this.formattedESResults = esResults;

      }).catch(()=>{

        this.setErrorMessage(CONSTANTS.ERROR_MESSAGE);
        this.showErrorMessage = true;
      }).finally(()=>{
        this.setShowSearchSpinner(false);
      })
      this.trackEvent("Page Hit: Guides Enterprise Search", this.searchTerm);
    },
    checkForExternalLink(url) {
      return !(url.toLowerCase().includes("/guides/"+this.currentAppData.alias.toLowerCase()))
    },
    searchDebounce: debounce(
            that => {
              that.getEnterpriseSearchResults();
            },
            1000,
            { leading: false }
    ),

    onSearchResultClicked() {
      this.$emit("clearSearchTerm");
    },
    buildSearchResultUrl(searchResult){
      if(searchResult.linkName){
        return searchResult.linkValue;
      }else {
         let id = this.isDisplayWithParentTypeSolution(searchResult) ? searchResult.parentCategoryId : searchResult.id
         return CONSTANTS.EH_URL +"/apps/new-guides/"+this.currentAlias+"/"+id;
      }
    },
    redirectToSolutionsModal(searchResult,clickEvent) {
      if(clickEvent)
        clickEvent.preventDefault();
      let event = this.currentAppData.enterpriseSearchQuery ? "Page Hit: Guides Enterprise Search - Search Result Selected" : "Page Hit: Guides Search - Search Result Selected"
      this.trackEvent(event, this.searchTerm, searchResult.linkValue);

      if(searchResult.linkName){
        searchResult.isExternalLink ? window.open(searchResult.linkValue, '_blank') : window.location.href = searchResult.linkValue
      }else {
        this.isDisplayWithParentTypeSolution(searchResult) ? this.navigateToRecord(searchResult.parentCategoryId) : this.navigateToRecord(searchResult.id)
      }

    },
    isDisplayWithParentTypeSolution(searchResult) {
      let displayWithParent = false
      if(searchResult.solutions && searchResult.solutions.length > 0) {
        searchResult.solutions.forEach(solution => {
          if(solution.pageType === "DISPLAY_WITH_PARENT") {
            displayWithParent = true
          }
        })
      }
      return displayWithParent
    },
    searchCategoryForSubstring(currentObj, key) {
      /* validate if current object[key] which has a stringValue has a searchTerm match */
      if(currentObj[key]) {
        if(currentObj[key].toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1) {
            return currentObj
        }
      }
    },
    searchCategoryForSubStringInArray(currentObj, key) {
      /* validate if current object[key] which has a arrayValue has a searchTerm match */
      if(currentObj[key] && currentObj[key].length > 0) {
        if(currentObj[key].findIndex(element => element.toLowerCase().includes(this.searchTerm.toLowerCase())) !== -1) {
          return currentObj
        }
      }
    },
    navigateToRecord(id) {
      this.setBreadcrumbItems([])
      let resultUrl = "";
      resultUrl = `/${this.currentAlias}/${id}`;
      this.onSearchResultClicked();
      if (id !== this.$route.params.id)
        this.$router.push(resultUrl);
    },
    getUniqueListBy(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()]
    },
    trackEvent(event, subEvent, eventUrl) {
      this.$hhMixpanel.trackEvent(event, {
        subEvent: "query="+subEvent,
        eventUrl: eventUrl
      });
    }
  },
};
</script>

<style scoped>
  .large-panel{
    margin:15px;
  }
.no-match-card {
  background-color: #f4f8fa;
  color: #979797;
  padding: 45px;
}
.no-match-card h4 {
  font-size: 26px !important;
}
.search-result-title {
  color: #5F60FF;
  font-family: artifaktElementBold;
  font-size: 16px;
  font-weight: bold;
}
  .search-results-panel {
    background-color: #fff;
    color: #979797;
    font-size: 16px;
    margin-bottom: 10px !important;
    margin-top: 0px !important;
    margin-left: 0px !important;
    margin-right: 0px !important;
    padding: 15px !important;
    min-height: 80px;
    border: 1px solid #64788D;
    border-radius: 3px;
  }
  .search-results-panel a:hover{
    color:#0056b3;
    text-decoration: none;
  }
  .search-result-desc{
    color:#000;
  }

  .span-tag {
    display: inline-block;
    margin-bottom: 4px;
    text-transform: uppercase;
    margin-right: 4px;
    background-color: #e0e0e0 !important;
    border: none !important;
    color: #666 !important;
    font-size: 12px !important;
    padding: 2px 4px !important;
    margin-top: 10px;
  }
</style>